<div class="form-group">
    <label class="checkbox-label text-muted" [for]="id">
        &nbsp;He leído y estoy de acuerdo con los&nbsp;
        <a [href]="path | urlNewTab"
            target="_blank" 
            class="font-weight-bold" 
            rel="nofollow"
            title="Ver las condiciones">Términos y Condiciones</a>.
        <input 
        [id]="id" 
        type="checkbox" 
        [name]="id"
        [formControl]="control" />
        <span class="checkmark"></span>
    </label>

    <div-validation-message 
    [control]="control"
    [messageRequired]="'Para continuar debes aceptar términos y condiciones.'"
    ></div-validation-message>

</div>